export default __webpack_public_path__ + "static/media/customerio-dark.c9cdb15e.png";